<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-12">
          <app-range-picker (submit)="filterTable($event)"></app-range-picker>
          <p class="text-muted">فاصله بین زمان شروع و زمان پایان حداکثر می تواند 31 روز باشد.</p>
        </div>
      </div>
      <div class="d-flex justify-content-start gap-3">
        <a
          class="go-to-page-button"
          nbButton
          status="primary"
          title="خروجی اکسل"
          target="_blank"
          (click)="exportexcel()"
        >
          خروجی اکسل&nbsp;
          <i class="far fa-cloud-download"></i>
        </a>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<nb-card>
  <nb-card-header>لیست گزارش برداشت ریالی</nb-card-header>
  <nb-card-body>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="false"
      [alwaysShowPaginator]="false"
      [rows]="100"
      [autoLayout]="true"
      [paginator]="true"
      [totalRecords]="pagination.data.length"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>شناسه کاربر</th>
          <th>شماره شبا</th>
          <th>مقدار</th>
          <th>کارمزد</th>
          <th>درگاه پرداخت</th>
          <th>تاریخ ایجاد</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-withdraw>
        <tr>
          <td>
            <a routerLink="/dashboard/user/{{ withdraw.userId }}" class="text-success">
              {{ withdraw.userId }}
            </a>
          </td>
          <td>
            {{ withdraw.iban }}
          </td>
          <td>
            {{ withdraw.amount | number : '1.0' }}
          </td>
          <td>
            {{ withdraw.fee | number : '1.0' }}
          </td>

          <td *ngIf="withdraw.provider; else empty">
            {{ withdraw.provider | provider }}
          </td>

          <td>
            {{ withdraw.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
          <ng-template #empty>
            <td>-</td>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
